import { render, staticRenderFns } from "./EventRegistrations.vue?vue&type=template&id=bdf11e78&"
import script from "./EventRegistrations.vue?vue&type=script&lang=js&"
export * from "./EventRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports